import Chart from "react-apexcharts";

const LineChart = (props) => {
  const { series, options } = props;
  const safeOptions = options && typeof options === "object" ? options : {};
  const safeSeries = Array.isArray(series) ? series : [];
  const chartHasDom = (chartContext) =>
    Boolean(chartContext?.w?.globals?.dom?.baseEl);

  return (
    <Chart
      options={{
        ...safeOptions,
        chart: {
          ...(safeOptions.chart || {}),
          events: {
            ...(safeOptions.chart?.events || {}),
            mouseMove: (event, chartContext) => {
              if (!chartHasDom(chartContext)) return;
              safeOptions.chart?.events?.mouseMove?.(event, chartContext);
            },
            mouseLeave: (event, chartContext) => {
              if (!chartHasDom(chartContext)) return;
              safeOptions.chart?.events?.mouseLeave?.(event, chartContext);
            },
            dataPointMouseEnter: (event, chartContext) => {
              if (!chartHasDom(chartContext)) return;
              safeOptions.chart?.events?.dataPointMouseEnter?.(event, chartContext);
            },
          },
        },
        tooltip: {
          ...(safeOptions.tooltip || {}),
          intersect: safeOptions.tooltip?.intersect ?? false,
        },
      }}
      type="line"
      width="100%"
      height="400"
      series={safeSeries}
    />
  );
};

export default LineChart;
